/**
 * Formateo de moneda y helpers visuales reusados por todas las pages.
 */

const MXN = new Intl.NumberFormat('es-MX', { style: 'currency', currency: 'MXN' });
const _formattersPorMoneda: Record<string, Intl.NumberFormat> = { MXN };

export function formatMXN(n: number | null | undefined): string {
  if (n == null) return '—';
  return MXN.format(n);
}

/** Formatea un monto en la moneda indicada (default MXN) — usar cuando el
 * job de conciliación mezcló más de una moneda (ver resumen_por_moneda). */
export function formatMonto(n: number | null | undefined, moneda?: string | null): string {
  if (n == null) return '—';
  const code = (moneda || 'MXN').toUpperCase();
  // Códigos inválidos o anómalos no deben cachearse ni usar Intl.
  if (!/^[A-Z]{3}$/.test(code)) return MXN.format(n);
  let fmt = _formattersPorMoneda[code];
  if (!fmt) {
    try {
      fmt = new Intl.NumberFormat('es-MX', { style: 'currency', currency: code });
      _formattersPorMoneda[code] = fmt; // cachear solo si Intl aceptó el código
    } catch {
      return MXN.format(n); // NO cachear el fallback bajo una clave inválida
    }
  }
  return fmt.format(n);
}

export function formatMXNShort(n: number | null | undefined): string {
  if (n == null) return '—';
  const abs = Math.abs(n);
  const sign = n < 0 ? '-' : '';
  if (abs >= 1_000_000_000) return `${sign}$${(abs / 1_000_000_000).toFixed(1)}B`;
  if (abs >= 1_000_000)     return `${sign}$${(abs / 1_000_000).toFixed(1)}M`;
  if (abs >= 1_000)         return `${sign}$${(abs / 1_000).toFixed(1)}K`;
  return MXN.format(n);
}

export function pctColor(pct: number): string {
  if (pct >= 80) return '#198754';
  if (pct >= 60) return '#ffc107';
  return '#dc3545';
}

export interface EstadoTag {
  text: string;
  bg:   string;
  color: string;
}

export function estadoLabel(pct: number): EstadoTag {
  if (pct >= 80) return { text: 'Al día',     bg: '#d1e7dd', color: '#0a3622' };
  if (pct >= 60) return { text: 'En proceso', bg: '#fff3cd', color: '#664d03' };
  return            { text: 'Atrasada',    bg: '#ffe0e0', color: '#7c1e1e' };
}

export function scoreColor(s: number): string {
  if (s >= 80) return '#198754';
  if (s >= 60) return '#fd7e14';
  return '#dc3545';
}

export function scoreLabel(s: number): string {
  if (s >= 80) return 'Alto';
  if (s >= 60) return 'Medio';
  return 'Bajo';
}

/** Quita el prefijo numérico (ej. "1. AAA") de un nombre de empresa. */
export function cleanEmpresa(name: string | null | undefined): string {
  if (!name) return '';
  return name.replace(/^\d+\.?\s+/, '');
}
